import { IIngredient } from '@app/common';
import { crudEndpoints } from '../crud-endpoints.factory';
import { rootApi } from '../api';

export const ingredientApi = rootApi.injectEndpoints({
  endpoints: (builder) => {
    const endpoints = crudEndpoints<IIngredient>(builder, 'ingredients', 'Ingredients');

    return {
      createOneIngredient: endpoints.createOne(),
      readManyIngredient: endpoints.readMany(),
      readOneIngredient: endpoints.readOne(),
      updateOneIngredient: endpoints.updateOne(),
      deleteOneIngredient: endpoints.deleteOne(),
      // LES RUPTURES (Maxence, 1er nov. 2026) : mêmes routes que la caisse, sur
      // la gateway dashboard, pour le restaurant de la barre latérale (`x-shop`).
      // La liste des ingrédients est invalidée : l'état par restaurant
      // (`ingredientShops`) se relit avec elle.
      createIngredientOutOfStock: builder.mutation<IIngredient, { ingredientId: string }>({
        query: ({ ingredientId }) => ({ url: `ingredients/${ingredientId}/out-of-stock`, method: 'POST' }),
        invalidatesTags: [{ type: 'Ingredients', id: 'LIST' }],
      }),
      deleteIngredientOutOfStock: builder.mutation<IIngredient, { ingredientId: string }>({
        query: ({ ingredientId }) => ({ url: `ingredients/${ingredientId}/out-of-stock`, method: 'DELETE' }),
        invalidatesTags: [{ type: 'Ingredients', id: 'LIST' }],
      }),
    }
  },
});
